import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingButtonComponent } from '../cp-loadingbutton/loadingbutton.component';

@NgModule({
  declarations: [LoadingButtonComponent],
  exports: [LoadingButtonComponent],
  imports: [CommonModule]
})

export class LoadingButtonModule {}

